import { Base } from "@studiometa/js-toolkit";
import { isFunction } from "@studiometa/js-toolkit/utils";
class Action extends Base {
  static config = {
    name: "Action",
    options: {
      on: {
        type: String,
        default: "click"
      },
      target: String,
      method: String,
      selector: String
    }
  };
  /**
   * Run method on targeted components
   */
  handleEvent() {
    const { target: componentNames, method, selector } = this.$options;
    let targets = componentNames.includes(" ") ? componentNames.split(" ").flatMap((componentName) => this.$root.$children?.[componentName]) : this.$root.$children?.[componentNames];
    if (!targets || !targets.length) {
      this.$warn("Target not found.");
      return;
    }
    if (selector || selector.length > 0) {
      targets = targets.filter((target) => target.$el.matches(selector));
    }
    if (!targets || !targets.length) {
      this.$warn(`Target with selector "${selector}" not found.`);
      return;
    }
    targets.forEach((target) => {
      if (!isFunction(target[method])) {
        this.$warn(`Method "${method}()" not found on target.`, target);
        return;
      }
      target[method]();
    });
  }
  /**
   * Mounted
   */
  mounted() {
    const { on: eventName, target, method } = this.$options;
    if (!target || !method || target.length <= 0 || method.length <= 0) {
      this.$warn("No target or method specified.");
      this.$terminate();
      return;
    }
    this.$el.addEventListener(eventName, this);
  }
  /**
   * Destroyed
   */
  destroyed() {
    this.$el.removeEventListener(this.$options.on, this);
  }
}
export {
  Action
};
//# sourceMappingURL=Action.js.map
